import React from "react";
import { connect } from "react-redux";
import PracticeSummaryComponent from "../components/PracticeSummaryComponent";
import LoaderPopUp from "../../../loader/loader";

function PracticeModeSummaryPage({loader}) {
  return (
    <div>
      <PracticeSummaryComponent />
      {loader && <LoaderPopUp />}
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    loader: state.ui.loader,
  };
};
export default connect(mapStateToProps)(PracticeModeSummaryPage);
